(() => {
  $(".groupsell-wrap").addClass("hide");

  $(`[name="payex_selector"]`).on("change", function () {
    $("#ProductSelect-product-template").val($(this).val());
    const option = $("#ProductSelect-product-template").find(
      `option[value="${$(this).val()}"]`,
    );

    $("#currentSelection").attr("data-variant", $(this).val());
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr(
      "data-voucher",
      option.attr("data-variantvoucher"),
    );

    updateLinks();
    // updatePrice();
    // updateVoucher();
  });
})();
